// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styles_bannerContainer__PKbu4","bannerText":"styles_bannerText__rwGWX"};